import { useState, useRef } from "react";
import classNames from "classnames";

import ss from "./code-input.module.css";

const CodeNumLength = 4;

export const CodeInput = (props) => {
  const { name, onChange } = props;
  const [code, setCode] = useState("");

  const handleChange = (e) => {
    const index = parseInt(e.target.dataset.index);
    const value = e.target.value;

    // 只取最后一个字符
    const lastChar = value.slice(-1);

    if (value) {
      // 输入
      if (code.length <= index) {
        const newCode = code + lastChar;
        setCode(newCode);
        onChange?.(newCode);
        // 输入下一个
        if (newCode.length < CodeNumLength) {
          const nextInput = document.querySelector(
            `#${name}[data-index="${newCode.length}"]`
          );
          if (nextInput) {
            nextInput.focus();
          }
        }
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      if (code.length > 0) {
        const newCode = code.slice(0, -1);
        setCode(newCode);
        onChange?.(newCode);
        // 返回上一个
        if (newCode.length > 0) {
          const prevInput = document.querySelector(
            `#${name}[data-index="${newCode.length - 1}"]`
          );
          if (prevInput) {
            prevInput.focus();
          }
        }
      }
    }
  };

  return (
    <div className={ss.codeInput}>
      {Array.from({ length: CodeNumLength }).map((_, index) => (
        <div
          className={classNames(ss.box, code.length >= CodeNumLength && ss.hl)}
          key={index}
        >
          <input
            id={name}
            type="number"
            data-index={index}
            value={code[index] || ""}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
          {index <= code.length - 1 && (
            <img
              className={ss.star}
              src={require("./imgs/code_input_star.png")}
            />
          )}
        </div>
      ))}
    </div>
  );
};
